import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    $('#loaderBox').fadeOut();
    localStorage.clear();
  }

}
